import { endpoints } from '../../../config';
import appClient, { ResultApi } from '../../common/services/AppClient';
import type { HomeShortcut } from '../types/HomeShortcut';

export class HomeShortcutsService {
    async getShortcuts(): Promise<ResultApi<HomeShortcut[]>> {
        return appClient.get<HomeShortcut[]>(`${endpoints.manageUrl}home-shortcuts`);
    }

    async createShortcut(formData: FormData): Promise<ResultApi<HomeShortcut>> {
        return appClient.post<HomeShortcut>(`${endpoints.manageUrl}home-shortcuts`, formData);
    }

    async updateShortcut(id: string, formData: FormData): Promise<ResultApi<HomeShortcut>> {
        return appClient.update<HomeShortcut>(`${endpoints.manageUrl}home-shortcuts/${id}`, formData);
    }

    async deleteShortcut(id: string): Promise<ResultApi<void>> {
        return appClient.delete<void>(`${endpoints.manageUrl}home-shortcuts/${id}`);
    }

    async reorder(orderedIds: string[]): Promise<ResultApi<void>> {
        return appClient.update<void>(`${endpoints.manageUrl}home-shortcuts/reorder`, { orderedIds });
    }

    async toggleVisibility(id: string, isVisible: boolean): Promise<ResultApi<HomeShortcut>> {
        return appClient.update<HomeShortcut>(`${endpoints.manageUrl}home-shortcuts/${id}/visibility`, { isVisible });
    }
}
